import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './App'

export function startDueDates(coursenum, restrictInstructor) {
  ReactDOM.render(
    <App coursenum={coursenum} restrictInstructor={restrictInstructor} />,
    document.getElementById('dueDates')
  )
}
